import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { DomSanitizer } from '@angular/platform-browser';

import { setScrollPosition } from 'app/inbox/inbox-deliveries/store/inbox.actions';
import { Delivery } from 'app/core/models';
import { PlatformService } from 'app/core/services/platform.service';
// import { selectDownloadConfig } from 'app/core/store/selectors/offline.selectors';
import { ConnectionService } from 'app/core/services/connection.service';
import { DeliveryService } from 'app/core/services/delivery.service';
import { InboxDelivery } from '../../../../inbox/inbox.model';
import { ModalsService } from '../../modals/modals.service';
import { ModalOfflineDeliveryComponent } from '../../modals/modal-offline-delivery/modal-offline-delivery.component';
import { DeliveryListService } from '../delivery-list.service';
import { Capacitor } from '@capacitor/core';

@Component({
  standalone: false,
  selector: 'pptl-delivery-thumbnail-view',
  templateUrl: './delivery-thumbnail-view.component.html',
  styleUrls: ['./delivery-thumbnail-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DeliveryThumbnailViewComponent implements AfterViewInit {
  @ViewChild('deliveryList') deliveryContainer;

  @Input() deliveries: InboxDelivery[] | Delivery[];
  @Output() chooseDelivery: EventEmitter<any> = new EventEmitter<any>();
  @Input() parentId?: 'current' | 'favorite' | 'history' | 'offline';
  @Input() scrollPosition = 0;
  @Output() pullDown: EventEmitter<any> = new EventEmitter<any>();
  @Output() scrollList: EventEmitter<any> = new EventEmitter<any>();

  noTrack = '/assets/images/no-track.jpg';
  isInfinityScrollShown = true;
  isOfflineModalShown = false;
  downloadConf$;

  constructor(
    private platformService: PlatformService,
    private store: Store,
    private deliveryService: DeliveryService,
    private modalsService: ModalsService,
    private connectionService: ConnectionService,
    private sanitize: DomSanitizer,
    private deliveryListService: DeliveryListService,
  ) {
    this.setDownloadConf();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.deliveryContainer && this.deliveries?.length > 10) {
        this.deliveryContainer.scrollToPoint(0, this.scrollPosition);
      }
    }, 350);
  }

  convertDate(date: string) {
    return this.deliveryListService.convertDate(date);
  }

  getDeliveryImage(delivery: Delivery): any {
    let imageUrl;

    imageUrl = delivery.thumbnailImage || delivery.deliveryImage || this.noTrack;

    if (this.isCachedUrl(imageUrl)) {
      const convertUrl = Capacitor.convertFileSrc(imageUrl).replace('undefined/', '');
      if (this.platformService.isIos()) {
        imageUrl = this.sanitize.bypassSecurityTrustResourceUrl(convertUrl);
      } else {
        imageUrl = convertUrl;
      }
    }

    return imageUrl;
  }

  goToDelivery(ev, delivery: Delivery) {
    ev.stopPropagation();
    this.setScrollPosition();
    if (this.parentId === 'offline') {
      if (this.deliveryService.isOfflineDeliveryExpired(delivery)) {
        this.showOfflineModal(delivery);
      } else {
        this.chooseDelivery.emit(delivery);
      }
    } else if (!delivery.expired) {
      this.chooseDelivery.emit(delivery);
    }
  }

  ionRefresh(event: any): void {
    this.hideInfinityScroll();
    this.pullDown.emit(event);
  }

  getDeliveryClasses() {
    return {
      mobile: this.isMobile && !this.isDesktop && !this.isTablet,
      desktop: this.isDesktop || (this.isMobileWeb && this.isTablet),
    };
  }

  trackByDeliveryKeyCode(index, delivery) {
    return delivery?.deliveryKeyCode;
  }

  get isMobile(): boolean {
    return this.platformService.isMobile();
  }

  get isTablet(): boolean {
    return this.platformService.isTablet();
  }

  get isMobileWeb() {
    return this.platformService.isMobileWeb();
  }

  get isDesktop(): boolean {
    return this.platformService.isDesktop();
  }

  get isDevicePlatform(): boolean {
    return this.platformService.isCordova();
  }

  get isOffline(): boolean {
    return !this.connectionService.isOnline;
  }

  showInfinityScroll(): boolean {
    return this.parentId !== 'offline' && this.isInfinityScrollShown;
  }

  onScroll(event: any): void {
    this.scrollList.emit(event);
  }

  private hideInfinityScroll() {
    this.isInfinityScrollShown = false;

    setTimeout(() => {
      this.isInfinityScrollShown = true;
    }, 100);
  }

  private setDownloadConf(): void {
    //this.downloadConf$ = this.store.pipe(select(selectDownloadConfig));
  }

  private async showOfflineModal(delivery: Delivery) {
    if (!this.isOfflineModalShown) {
      this.isOfflineModalShown = true;

      const onModalClose = await this.modalsService.showModal({
        component: ModalOfflineDeliveryComponent,
        cssClass: 'modal-offline-delivery',
        backdropDismiss: false,
        componentProps: {
          delivery,
        },
      });

      onModalClose.then(() => {
        this.isOfflineModalShown = false;
      });
    }
  }

  private setScrollPosition() {
    this.deliveryContainer.getScrollElement().then((scrollPosition: any) => {
      this.store.dispatch(setScrollPosition({ scrollPosition: scrollPosition.scrollTop }));
    });
  }

  private isCachedUrl(url): boolean {
    return this.isMobile && url?.includes('file://');
  }
}
